import React, { useEffect, useState } from "react";
import * as interviewWizardService from "../services/interviewWizardService";
import { PersonMatchModal } from "../../../components/PersonMatchModal/PersonMatchModal";
import { LoadingBar } from "../../../components/LoadingComponents/LoadingBar";
import { getMatchingPerson } from "../services/personMatchService";
import Axios from "axios";
import { cloneEncounterIntoAnother } from "../../../actions/interviewActions";
import { withUser } from "@coverme/identity";

const InterviewInitialization = ({
    match,
    currentSection,
    interview,
    lookups,
    history,
    user,
    forceUpdate,
    customerId,
}) => {
    const [shouldShowPersonMatchModal, setShouldShowPersonMatchModal] = useState(false);
    const [shouldShowLoadingBar, setShouldShowLoadingBar] = useState(false);
    const [matchingPersons, setMatchingPersons] = useState([]);
    useEffect(() => {
        if (interview.encounterStatus === "New") {
            setShouldShowLoadingBar(true);
            const patient = interview?.entry?.patient;
            getMatchingPerson(customerId, {
                firstName: patient?.firstName,
                middleInitial: patient?.middleInitial,
                lastName: patient?.lastName,
                nameSuffix: patient?.suffix,
                socialSecurityNumber: patient?.ssn,
                dateOfBirth: patient?.dob,
                mrn: patient?.mrn,
                documentType: patient?.documentInfo?.documentType,
                documentId: patient?.documentInfo?.documentNumber,
            }).then(data => {
                setShouldShowPersonMatchModal(true);
                setShouldShowLoadingBar(false);
                setMatchingPersons(data.data);
            });
        } else {
            const url = interviewWizardService.getFurthestPage(
                match.url,
                currentSection,
                interview,
                lookups.data.configuration
            );
            history.replace(url);
        }
    }, []);

    return (
        <div>
            <LoadingBar isLoading={shouldShowLoadingBar}>
                <PersonMatchModal
                    isShown={shouldShowPersonMatchModal}
                    user={user}
                    persons={matchingPersons}
                    history={history}
                    onClose={() => {
                        setShouldShowPersonMatchModal(false);
                    }}
                    onNoMatchFound={() => {
                        // setSimplePersonDemographics(formData);
                        history.push(`/interview/${interview.encounterId}/entry`);
                    }}
                    onPersonVerify={(shouldStartNow, selectedPersonId) => {
                        Axios.get(`/api/customer/${customerId}/person/${selectedPersonId}/encounter/latest`).then(result => {
                            cloneEncounterIntoAnother(result.data, interview.encounterId).then(r => {
                                if (shouldStartNow) {
                                    window.location.href = `/interview/${interview.encounterId}/entry`;
                                } else {
                                    setShouldShowPersonMatchModal(false);
                                    return history.push("/");
                                }
                            });
                        });
                    }}
                />
            </LoadingBar>
        </div>
    );
};

export const InterviewInitializationComponent = withUser(InterviewInitialization);
